export const googleTagManagerScripts = {
  forHead: (id: string, nonce: string) => `
      <!-- Google Tag Manager -->
        <script nonce='${nonce}'>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id}');</script>
      <!-- End Google Tag Manager -->
  `,
  forBody: (id: string) => `
      <!-- Google Tag Manager (noscript) -->
        <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
        </noscript>
      <!-- End Google Tag Manager (noscript) -->
    `,
};

export const yandexMetrikaCounterScripts = {
  forHead: (id: string, nonce: string) => `
    <!-- Yandex.Metrika counter -->
      <script nonce='${nonce}' type="text/javascript" >
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
        ym(${id}, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true,
            webvisor:true
        });
      </script>
    <!-- End Yandex.Metrika counter -->
  `,
  forBody: (id: string) => `
      <!-- Yandex.Metrika counter (noscript) -->
        <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
        </noscript>
      <!-- End  Yandex.Metrika counter (noscript) -->
    `,
};
